// extracted by mini-css-extract-plugin
export default {"dialog":"AiCreationDialog_dialog__WWurN","content":"AiCreationDialog_content__kXe9J"};